import React from 'react';
import classnames from 'classnames';
import styles from "../../../admin/styles.module.scss";
import { MdDelete, MdEdit } from 'react-icons/md';
import { TooltipTop } from '@components/tooltips';
import { EyeIcon } from '@pages/workflow-analytics-page/assets/icons';
import { ModelRequestType } from './constant';
import { ScheduleTiming } from '@pages/workflow-page/modals/schedule-workflow';
import { ShowWhenTrue } from '@helpers/showwhentrue';

type ModelRequestsDataProps = {
    data: ModelRequestType[] | null;
    handleDelete: (item: ModelRequestType) => void;
    handleEdit: (item: ModelRequestType) => void;
    handleViewRequests: (item: ModelRequestType) => void;
    isRdbmsView?: boolean;
};

const ModelRequestsLists: React.FC<ModelRequestsDataProps> = ({ data, handleDelete, handleEdit, handleViewRequests, isRdbmsView = false }) => {

    return (
        <div className={styles["assetList"]}>
            <ul className={classnames(styles['nifi_titles'])} style={{ maxHeight: '74vh' }}>
                {data?.map((item, index) => (
                    <li key={index}>
                        <div>
                            <div className={styles['key']}>Name</div>
                            <TooltipTop title={item.modelRequestName}>
                                <div className={styles['hierarchyName']}>{item.modelRequestName}</div>
                            </TooltipTop>
                        </div>
                        <div className={styles['divider']}></div>
                        <div>
                            <div className={styles['key']}>Sink Name</div>
                            <div>{item?.sinkDetails?.sinkName}</div>
                        </div>
                        <div>
                            <div className={styles['key']}>Sink Type</div>
                            <div>{item?.sinkDetails?.sinkKind}</div>
                        </div>
                        <div>
                            <div className={styles['key']}>Schedule Type</div>
                            <div>{item.dagGenDto?.schedule_interval === "@once" ? ScheduleTiming["Run Once"] : ScheduleTiming["Recurring"]}</div>
                        </div>
                        <ShowWhenTrue show={!isRdbmsView}>
                            <div>
                                <div className={styles['key']}>Landing Type</div>
                                <div>{item.sinkDetails?.databaseType}</div>
                            </div>
                        </ShowWhenTrue>
                        <div className={styles['divider']}></div>


                        <div className={styles.actions}>
                            <TooltipTop title="Edit">
                                <button
                                    className={styles.actionButton}
                                    onClick={() => handleEdit(item)}
                                >
                                    <div className={styles.center}>

                                        <MdEdit size={"24px"} />
                                    </div>
                                </button>
                            </TooltipTop>
                            <TooltipTop title="View">
                                <button
                                    className={styles.actionButton}
                                    onClick={() => handleViewRequests(item)}
                                >
                                    <div className={styles['center']}>
                                        <EyeIcon />
                                    </div>
                                </button>
                            </TooltipTop>
                            <TooltipTop title="Delete">
                                <button
                                    className={styles.deleteButton}
                                    onClick={() => handleDelete(item)}
                                >
                                    <div className={styles.actionButton}>
                                        <MdDelete size={"24px"} />
                                    </div>
                                </button>
                            </TooltipTop>
                        </div>
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default ModelRequestsLists;
